module.exports = __webpack_public_path__ + "static/media/fruit_scones.90846e33.jpg";